export const SUPPORTED_PAYMENT_CURRENCIES = [
  { value: "DKK", label: "Danish Krone (DKK)" },
  { value: "SEK", label: "Swedish Krona (SEK)" },
  { value: "NOK", label: "Norwegian Krone (NOK)" },
  { value: "GBP", label: "British Pound (GBP)" },
  { value: "USD", label: "US Dollar (USD)" },
  { value: "PLN", label: "Polish Zloty (PLN)" }
];

export const DEFAULT_PAYMENT_CURRENCY = "DKK";

export function normalizePaymentCurrencyCode(value) {
  const normalizedValue = String(value || "").trim().toUpperCase();

  if (SUPPORTED_PAYMENT_CURRENCIES.some((currency) => currency.value === normalizedValue)) {
    return normalizedValue;
  }

  return DEFAULT_PAYMENT_CURRENCY;
}

export function formatEuroAmount(value) {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return "0.00 €";
  }

  return `${numericValue.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} €`;
}

export function formatCodeAmount(value, currencyCode) {
  const numericValue = Number(value);
  const normalizedCurrencyCode = normalizePaymentCurrencyCode(currencyCode);

  if (!Number.isFinite(numericValue)) {
    return `0.00 ${normalizedCurrencyCode}`;
  }

  return `${numericValue.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} ${normalizedCurrencyCode}`;
}

export function convertEuroAmount(value, currencyCode, exchangeRates = {}) {
  const numericValue = Number(value);
  const normalizedCurrencyCode = normalizePaymentCurrencyCode(currencyCode);
  const exchangeRate = Number(exchangeRates?.[normalizedCurrencyCode]);

  if (!Number.isFinite(numericValue) || !Number.isFinite(exchangeRate) || exchangeRate <= 0) {
    return null;
  }

  return Math.round(((numericValue * exchangeRate) + Number.EPSILON) * 100) / 100;
}

export function formatPaymentWithConversion(value, settings = {}, exchangeRates = {}) {
  const baseValue = formatEuroAmount(value);

  if (!settings?.paymentConversionEnabled) {
    return baseValue;
  }

  const currencyCode = normalizePaymentCurrencyCode(settings?.paymentCurrencyCode);
  const convertedValue = convertEuroAmount(value, currencyCode, exchangeRates);

  if (convertedValue === null) {
    return baseValue;
  }

  return `${baseValue} (${formatCodeAmount(convertedValue, currencyCode)})`;
}